import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Field, getFormSyncErrors } from 'redux-form';
import styled, { css } from 'styled-components';
import FormGroup from '../../components/FormGroup';
import Icon from '../../components/Icon';
import renderInput from '../../components/Input/redux-form';
import Label from '../../components/Label';
import Loader from '../../components/Loader';
import { formatPrice, getProp, __ } from '../../utilities';
import { NUMBER_PLACEHOLDER } from '../Login/registrationForm';
import { FORM_NAME } from './form';
import {
  ticketsIsFetchingSelector,
  ticketsSelector,
  totalPriceForEachPassengerSelector,
} from './selectors';
import TarrifPicker from './TarrifPicker/';

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  ${({ theme }) => theme.media.sm`  
    flex-direction: row;
  `};
`;

export const Col = styled.div`
  width: calc(100% - ${rem(10)});
  color: ${({ theme }) => theme.color.font.secondary};
  ${({ theme }) => theme.media.sm`  
    width: calc(50% - ${rem(10)});    
  `};
`;

const Title = styled.div`
  font-size: ${rem(20)};
`;

const MainPerson = styled.span`
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.color.font.secondary};
`;

const RemoveSpan = styled.span`
  display: flex;
  span {
    margin-right: ${rem(10)};
  }
  &:hover {
    cursor: pointer;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${rem(20)};
`;

const Wrapper = styled.div`
  padding: ${rem(30)} 1.125rem;
  background-color: #fff;
  ${({ theme }) => theme.media.sm`
    padding: ${rem(35)} ${rem(50)};
  `};
  box-shadow: ${({ theme }) => theme.shadow};
  margin-bottom: ${rem(10)};
`;

const Tab = styled.div`
  padding: ${rem(10)};
  border-radius: ${({ theme }) => theme.borderRadius}
    ${({ theme }) => theme.borderRadius} 0 0;
  margin-right: ${rem(4)};
  border: ${rem(1)} solid ${({ theme }) => theme.color.separator};

  ${props => {
    if (props.selected) {
      return css`
        border-bottom: #fff;
        color: ${props.isValid
          ? props.theme.color.font.primary
          : props.theme.color.danger};
        background-color: #fff;
        margin-bottom: -${rem(1)};
      `;
    }
    return css`
      color: ${props.isValid
        ? props.theme.color.font.primary
        : props.theme.color.danger};
      background-color: #e0e0e0;
    `;
  }};
  &:hover {
    cursor: pointer;
  }
`;

const Taber = styled.div`
  display: flex;
`;

const TicketTitle = styled.div`
  font-size: ${rem(20)};
  margin-bottom: ${rem(10)};
`;

export const Total = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${rem(15)};
  align-items: center;
`;

export const TotalPrice = styled.div`
  font-size: ${rem(20)};
  color: ${({ theme }) => theme.color.primary};
  font-weight: bold;
  margin-left: ${rem(15)};
`;

export const TotalText = styled.span`
  color: ${({ theme }) => theme.color.font.primary};
`;

class renderTickets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTicketTabByPassengerIdx: {},
    };
    this.handleClickTab = this.handleClickTab.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.tickets !== this.props.tickets) {
      this.setState({ selectedTicketTabByPassengerIdx: {} });
    }
  }

  handleClickTab(passengerIdx, ticketIdx) {
    const selected = { ...this.state.selectedTicketTabByPassengerIdx };
    selected[passengerIdx] = ticketIdx;
    this.setState({ selectedTicketTabByPassengerIdx: selected });
  }

  render() {
    const { fields, tickets, totalPrices, formErrors } = this.props;

    const { selectedTicketTabByPassengerIdx } = this.state;
    const persons = [];
    fields.forEach((passenger, passengerIdx) => {
      let selectedTicketIdx = selectedTicketTabByPassengerIdx[passengerIdx];
      if (typeof selectedTicketIdx === 'undefined') {
        selectedTicketIdx = 0;
      }
      const component = (
        <Wrapper key={passengerIdx.toString()}>
          <Header>
            <Title>
              {`${__('Cestujúci číslo')} ${passengerIdx + 1}`}
              {passengerIdx === 0 && (
                <MainPerson>{__('(Hlavný cestujúci)')}</MainPerson>
              )}
            </Title>
            {passengerIdx !== 0 && (
              <RemoveSpan
                onClick={e => {
                  e.preventDefault();
                  fields.remove(passengerIdx);
                }}
              >
                <span>{__('Odstrániť cestujúceho')}</span>
                <Icon name="remove" />
              </RemoveSpan>
            )}
          </Header>
          <Row>
            <Col>
              <FormGroup>
                <Label required>{__('Meno')}</Label>
                <Field
                  name={`${passenger}.name`}
                  type="text"
                  component={renderInput}
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label required>{__('Priezvisko')}</Label>
                <Field
                  name={`${passenger}.surname`}
                  type="text"
                  component={renderInput}
                />
              </FormGroup>
            </Col>
          </Row>
          {passengerIdx === 0 && (
            <div>
              <Row>
                <Col>
                  <FormGroup>
                    <Label required>{__('Email')}</Label>
                    <Field
                      name={`${passenger}.email`}
                      type="email"
                      component={renderInput}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label required>{__('Tel. číslo')}</Label>
                    <Field
                      name={`${passenger}.phone`}
                      type="tel"
                      component={renderInput}
                      placeholder={NUMBER_PLACEHOLDER}
                    />
                    <span>
                      {__('Požadovaný formát je ')}
                      {NUMBER_PLACEHOLDER}
                    </span>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          )}
          <div>
            <TicketTitle>{__('Lístky')}</TicketTitle>

            {this.props.isFetching ? (
              <Loader
                size="xl"
                text={__('Načítavajú sa ceny cestovných lístkov')}
              />
            ) : (
              <div>
                <Taber>
                  {tickets.map((ticket, ticketIdx) => {
                    const isValid =
                      getProp(formErrors, [
                        'passengers',
                        passengerIdx,
                        'tickets',
                        ticketIdx,
                      ]) === '';
                    const isSelected = selectedTicketIdx === ticketIdx;
                    return (
                      <Tab
                        isValid={isValid}
                        key={ticketIdx.toString()}
                        selected={isSelected}
                        onClick={() => {
                          this.handleClickTab(passengerIdx, ticketIdx);
                        }}
                      >
                        {`${ticketIdx + 1}${__('. Lístok')}`}{' '}
                        {!isValid && __(' - Vyberte tarifu')}
                      </Tab>
                    );
                  })}
                </Taber>
                {tickets.map((ticket, ticketIdx) => {
                  if (ticketIdx === selectedTicketIdx) {
                    const fieldName = `${passenger}.ticket.${ticketIdx}`;
                    return (
                      <Field
                        name={fieldName}
                        component={TarrifPicker}
                        ticketIdx={ticketIdx}
                        tarrifs={getProp(ticket, ['tarrif'], [])}
                        ticket={ticket}
                      />
                    );
                  }
                  return null;
                })}
              </div>
            )}

            <Total>
              <TotalText>{__('Cena za cestujúceho')}</TotalText>
              <TotalPrice>{formatPrice(totalPrices[passengerIdx])}</TotalPrice>
            </Total>
          </div>
        </Wrapper>
      );
      persons.push(component);
    });

    return (
      <div>
        <div>{persons}</div>
      </div>
    );
  }
}

renderTickets.propTypes = {
  fields: PropTypes.shape({}).isRequired,
  tickets: PropTypes.arrayOf({
    tt: PropTypes.string.isRequired,
    way1_from: PropTypes.string.isRequired,
    way1_to: PropTypes.string.isRequired,
  }),
  selectedTabs: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  onClickTag: PropTypes.func.isRequired,
  totalPrices: PropTypes.arrayOf(PropTypes.number),
};

renderTickets.defaultProps = {
  tickets: [],
  totalPrices: [],
};

const mapStateToProps = state => {
  return {
    formErrors: getFormSyncErrors(FORM_NAME)(state),
    tickets: ticketsSelector(state),
    totalPrices: totalPriceForEachPassengerSelector(state),
    isFetching: ticketsIsFetchingSelector(state),
  };
};

const withRouterComponent = withRouter(renderTickets);
export default connect(mapStateToProps)(withRouterComponent);



// WEBPACK FOOTER //
// ./src/containers/Passengers/subForm.js